export async function fetchLeaderboard({ token, sessionId, organizationId, lobby_name }) {
  const lobby = String(lobby_name ?? '').trim();
  if (!lobby) {
    throw new Error('lobby_name is required');
  }

  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/fetchLeaderboard`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      sessionId,
      organizationId,
      lobby_name: lobby,
    }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || 'Failed to fetch leaderboard');
  }
  if (data && data.success === false) {
    throw new Error(data.message || 'Failed to fetch leaderboard');
  }
  return data.data || [];
}
